import { Box } from '@mui/material';

const HorizontalBar = () => {
  return (
    <Box
    sx={{ px: {xs: 4, md: 20} }}
    >
      <Box
        sx={{
          height: '4px',
          width: "100%",
          borderRadius: '10px',
          backgroundColor: (theme)=>theme.palette.primary.main,
        }}
      />
    </Box>
  );
};

export default HorizontalBar;
